import {
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
  useState,
} from "react";
import Select, { ActionMeta, MultiValue } from 'react-select';


import useForm from "../../hooks/useForm";
import {
  initialRecipe,
  propsRecipe,
} from "../../utils/formsInitialsStates";
import { useDoneFetchActions } from "../../hooks/useDoneFetchActions";
import { getProductos } from "../../services/fabricaServices";


interface Props {
  handleSubmit?: (values: propsRecipe) => void;
  data?: propsRecipe;
  on?: string;
}

export const RecetaForm = forwardRef(({ handleSubmit, data }: Props, ref) => {
  const doneFetchActions = useDoneFetchActions();
  const { handleInputChange, formValues, resetForm, changeMulti, validateForm } = useForm<propsRecipe>(initialRecipe);
  const form = useRef<HTMLFormElement>(null);

  const [productos, setProductos] = useState<{ id: number; nombre: string; unidad_medida: string | null }[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<{ value: number; label: string; }[]>([]);

  const submitForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit && handleSubmit(formValues);
  };

  useEffect(() => {
    doneFetchActions(getProductos()).then((resp) => {
      setProductos(resp);
    });
  }, [doneFetchActions]);

  useEffect(() => {
    if (data) {
      const selectedMaterials = data.recetaMaterial.map((material) => ({
        value: material.material_id,
        label: productos.find((producto) => producto.id === material.material_id)?.nombre || ''
      }));
      setSelectedOptions(selectedMaterials);
      changeMulti({
        ...data,
        recetaMaterial: data.recetaMaterial.map((material) => ({
          material_id: material.material_id
        }))
      });
    }
  }, [data, changeMulti, productos]);

  const handleSelectChange = (newValue: MultiValue<{ value: number; label: string; }>, actionMeta: ActionMeta<{ value: number; label: string; }>) => {
    setSelectedOptions(newValue as { value: number; label: string; }[]);

    const selectedProducts = (newValue as { value: number; label: string; }[]).map(option => {
      const selectedProduct = productos.find(producto => producto.id === option.value);
      return selectedProduct ? {
        material_id: selectedProduct.id
      } : null;
    }).filter(Boolean) as { material_id: number }[];

    changeMulti({ recetaMaterial: selectedProducts });
  };

  useImperativeHandle(ref, () => ({
    handleClick: () => {
      form.current?.requestSubmit();
      if (form.current && validateForm(form.current.elements)) {
        return formValues;
      }
    },
    resetForm: () => {
      resetForm();
    },
  }));

  return (
    <form
      className="p-3"
      id="formBancos"
      ref={form}
      autoComplete="off"
      onSubmit={submitForm}
      noValidate
    >
      <div className="row">
        <div className="col-md-8">
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="receta"
              name="receta"
              value={formValues.receta}
              onChange={handleInputChange}
              placeholder="-"
              data-uppercase="change"
              data-trim="submit"
              required
            />
            <label htmlFor="receta">Nombre de la receta</label>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8">
          <div className="form-floating mb-3">
            <Select
              id="material_id"
              name="material_id"
              placeholder='Seleccione Material'
              value={selectedOptions}
              isMulti
              closeMenuOnSelect={false}
              options={productos.map((p) => ({ value: p.id, label: p.nombre }))}
              onChange={handleSelectChange}
              required
            />
            <label htmlFor="material_id"></label>
          </div>
        </div>
      </div>

      <div className="row">
        {formValues.recetaMaterial.map((material) => (
          <div className="col-md-6 mb-3" key={material.material_id}>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={productos.find(p => p.id === material.material_id)?.nombre || ''}
                readOnly
              />
            </div>
          </div>
        ))}
      </div>
        <div className="row">
          <div className="col-md-8">
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="descripcion"
                name="descripcion"
                value={formValues.descripcion}
                onChange={handleInputChange}
                placeholder="Descripción..."
                required
              />
              <label htmlFor="descripcion">Descripción de la receta</label>
            </div>
          </div>
        </div>
        <div className="row">
        <div className="col-md-8">
          <div className="form-floating mb-3">
            <select className="form-select" id="estado" name="estado" value={Number(formValues.estado)} onChange={handleInputChange} required>
              <option value="" disabled>Seleccione un estado</option>
              <option value={1}>Habilitado</option>
              <option value={0}>Inhabilitado</option>
            </select>
            <label htmlFor="estado">Habilitar/Inhabilitar</label>
          </div>
        </div>
        </div>
      </form>
    );
  }
);